

export const VEHICLE_OBJECT = {
    "absBreak": "0",
    "accessoryValue": "0",
    "adatCruise": "0",
    "agencyRepairRequired": 'N',
    "antiBreak": "0",
    "antiTheft": "0",
    "axleWeight": "0",
    "camera360": "0",
    "carModifiedDescription": null,
    "chassisNumber": null,
    "colorCode": null,
    "cruise": "0",
    "currentMileage": null,
    "customCardNumber": null,
    "deductible": null,
    "deductibleForUnifiedForm": "500",
    "engineSizeCode": null,
    "engineSizeName": null,
    "fireExtinguisher": "0",
    "frontCamera": "0",
    "isCarModified": "N",
    "majorDrivingCityCode": '38',
    "majorDrivingRegionCode": '1',
    "makeCode": null,
    "milagePerYearName": null,
    "mileagePerYearCode": '2',
    "modelCode": null,
    "parkFrontSensors": "0",
    "parkRearSensors": "0",
    "parkingLocationCode": "MOTOR_AR_ONROAD",
    "parkingLocationName": null,
    "plateNumber": null,
    "plateTextLeft": null,
    "plateTextMiddle": null,
    "plateTextRight": null,
    "plateTypeCode": "1",
    "priorPolicyCompanyName": null,
    "priorPolicyExpiryDate": null,
    "priorPolicyNumber": null,
    "rearCamera": "0",
    "registrationExpiryDate": null,
    "seatingCapacity": null,
    "selectedFeatures": null,
    "serialNumber": null,
    "transferOwnerId": null,
    "transmissionCode": "1",
    "transmissionName": null,
    "usageTypeCode": "PRIVATE",
    "vehicleDocumentsArray": null,
    "vehicleQuestionAnswerArray": null,
    "vehicleTransferFlag": "N",
    "vehicleValue": null,
    "yearOfManufacture": null,
    "vehicleDriverDetails": {
        "vehicleDriverDetailsArray": [

        ]
    },
    "mbiPlan": '',
    "colorName": null,
    "ncdValue": null
}

export const DRIVER_OBJECT = {
    "accidentsIn5YearsCode": null,
    "accidentsIn5YearsName": null,
    "araFirstName": null,
    "araFullName": null,
    "araLastName": null,
    "araMidName": null,
    "driverTypeName": null,
    "childUnderSixteenCode": "0",
    "childUnderSixteenName": "0",
    "claimsIn5YearsCode": null,
    "claimsIn5YearsName": null,
    "driverNCD": null,
    "driverRelationCode": "NOR",
    "driverRelationName": null,
    "driverType": "AD",
    "driverUsagePercentageCode": null,
    "driverUsagePercentageName": null,
    "educationCode": "GRD",
    "educationName": "Graduation",
    "engFirstName": null,
    "engFullName": null,
    "engLastName": null,
    "engMidName": " -",
    "genderCode": null,
    "genderName": null,
    "gregDob": null,
    "hijDob": null,
    "homeSelfUnitNumber": null,
    "homeWaselAdditionalNumber": null,
    "homeWaselAraDistrictName": null,
    "homeWaselAraStreetName": null,
    "homeWaselBuildingNumber": null,
    "homeWaselCityCode": null,
    "homeWaselCityName": null,
    "homeWaselEngDistrictName": null,
    "homeWaselEngStreetName": null,
    "homeWaselPostalCode": null,
    "homeWaselRegionCode": null,
    "homeWaselRegionName": null,
    "IDNO": null,
    "isPolicyHolder": null,
    "licenseExperienceArray": [
        {
            "countryCode": "NA",
            "countryLicenseDurationCode": "0",
            "countryLicenseDurationName": "0 Year",
            "countryName": null
        },
    ],
    "licenseExpiryDate": null,
    "licenseIssueDate": null,
    "licenseTypeCode": null,
    "licenseTypeName": null,
    "maritalStatusCode": null,
    "maritalStatusName": null,
    "medicalConditionsCode": null,
    "medicalConditionsName": null,
    "mobile": null,
    "nationalityCode": null,
    "nationalityName": null,
    "occupationCode": null,
    "occupationName": null,
    "officeaddressgeneral": null,
    "officeSelfUnitNumber": null,
    "officeWaselAdditionalNumber": null,
    "officeWaselAraDistrictName": null,
    "officeWaselAraStreetName": null,
    "officeWaselBuildingNumber": null,
    "officeWaselCityCode": null,
    "officeWaselCityName": null,
    "officeWaselEngDistrictName": null,
    "officeWaselEngStreetName": null,
    "officeWaselPostalCode": null,
    "officeWaselRegionCode": null,
    "officeWaselRegionName": null,
    "roadConvictionsCode": null,
    "roadConvictionsName": null,
    "saudiDrivingLicenseExpCode": null,
    "saudiDrivingLicenseExpName": null,
    "saudiLicenseNumber": null,
    vehicle : null
}

